import React from 'react';

/**
 * AppIconButton — icon-only action button for toolbars and inline actions.
 *
 * Default style is ghost. Use `danger` for destructive actions.
 * Use `variant="secondary"` for bordered icon buttons.
 * Use `round` for circular toolbar buttons (refresh, close, etc.).
 */
const AppIconButton = ({
    icon,
    onClick,
    title,
    disabled = false,
    danger = false,
    variant,
    round = false,
    loading = false,
    size = '0.85rem',
    className = '',
    ...rest
}) => {
    const cls = [
        'fk-icon-btn',
        danger && 'fk-icon-btn--danger',
        variant === 'secondary' && 'fk-icon-btn--secondary',
        round && 'fk-icon-btn--round',
        className,
    ].filter(Boolean).join(' ');

    return (
        <button
            className={cls}
            onClick={onClick}
            title={title}
            disabled={disabled || loading}
            type="button"
            {...rest}
        >
            <i className={loading ? 'pi pi-spin pi-spinner' : icon} style={{ fontSize: size }} />
        </button>
    );
};

export default AppIconButton;
